import React from "react";
import { Box, Skeleton, Stack, Avatar, Button } from "@mui/material";

const ProfileFormSkeleton = () => {
    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: 400,
                mx: "auto",
                p: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            {/* Upload Image */}
            <Box sx={{ position: "relative", mb: 2 }}>
                <Skeleton variant="circular" width={100} height={100} />
            </Box>

            {/* First Name */}
            <Stack spacing={1} sx={{ width: "100%", mb: 2 }}>
                <Skeleton variant="text" width="40%" height={20} />
                <Skeleton variant="rectangular" width="100%" height={40} />
            </Stack>

            {/* Last Name */}
            <Stack spacing={1} sx={{ width: "100%", mb: 2 }}>
                <Skeleton variant="text" width="40%" height={20} />
                <Skeleton variant="rectangular" width="100%" height={40} />
            </Stack>

            {/* Current Relationship */}
            <Stack spacing={1} sx={{ width: "100%", mb: 2 }}>
                <Skeleton variant="text" width="70%" height={20} />
            </Stack>

            {/* Change Relationship */}
            <Stack spacing={1} sx={{ width: "100%", mb: 3 }}>
                <Skeleton variant="text" width="60%" height={20} />
                <Skeleton variant="rectangular" width="100%" height={40} />
            </Stack>

            {/* Buttons */}
            {/* <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    gap: 2,
                }}
            >
                <Skeleton
                    variant="rectangular"
                    width="48%"
                    height={45}
                    sx={{ borderRadius: 25 }}
                />
                <Skeleton
                    variant="rectangular"
                    width="48%"
                    height={45}
                    sx={{ borderRadius: 25 }}
                />
            </Box> */}
        </Box>
    );
};

export default ProfileFormSkeleton;
